module.exports = __webpack_public_path__ + "img/area-comum-09.1bf50ed9.png";